/*
  CLUE - Infinite scroll / Load more for collection pages
  Theme: Symmetry 8.3.1 (Clean Canvas), theme file clue-wear/main
  Version 1.1 - 02 Aug 2026

  MODES (chosen in Customize -> Collection pages -> "Pagination style")
    Numbered pagination  - this file is not even loaded; the theme is stock.
    Infinite scroll      - next page loads as the shopper nears the bottom.
    Load more button     - next page loads when the shopper clicks the button.

  The mode arrives on the script tag rendered by main-collection.liquid:
    <script src=".../clue-infinite-scroll.js" defer data-clue-mode="infinite">
  A tag with no data-clue-mode attribute behaves as "infinite" (v1.0 installs).

  WHY IT IS SAFE
    - Adds no markup to the theme. It only reads what main-collection.liquid
      already renders (.product-grid, .pagination-row, .pagination__next).
    - Does not touch main.js and does not override any theme function.
    - Survives Symmetry's AJAX filter/sort swap: it watches .pagination-row,
      which the theme replaces on every filter, sort or page change, and
      restarts itself from page 1 of the new result set.
    - On ANY failure (network, unexpected markup, old browser) it un-hides the
      real pagination and stops. The page is then exactly as it is today.
    - Does nothing at all when the collection fits on one page.

  TUNING - the values directly below are the only things to change.
*/
(function () {
  'use strict';

  /* =============================== tuning =============================== */

  // Infinite mode only: how far before the end of the grid the next page
  // starts loading (px). Bigger = smoother but more requests. 800 is about
  // one screen ahead.
  var LOAD_AHEAD_PX = 800;

  // Infinite mode only:
  // 0 = keep loading to the end of the collection.
  // Any other number = auto-load that many extra pages, then bring the normal
  // pagination back so the shopper can carry on by hand (and reach the footer).
  var MAX_AUTO_PAGES = 0;

  // true  = new products fade in the same way the first page does
  // false = new products appear instantly
  var ANIMATE_NEW_PRODUCTS = true;

  var TEXT_LOADING = 'Loading more products';
  var TEXT_LOAD_MORE = 'Load more';

  /* ============================ end of tuning =========================== */

  var SUPPORTED = 'IntersectionObserver' in window
    && 'MutationObserver' in window
    && typeof window.fetch === 'function'
    && typeof window.Promise === 'function';

  if (!SUPPORTED) return;
  if (window.clueInfiniteScroll) return;

  var MODE = 'infinite'; // 'infinite' | 'load_more', resolved in init()

  var s = {
    mode: MODE,
    section: null,
    grid: null,
    paginationRow: null,
    sentinel: null,
    io: null,
    mo: null,
    nextUrl: null,
    sectionId: null,
    pagesLoaded: 0,
    busy: false,
    stopped: false,
    controller: null
  };

  function qs(sel, root) { return (root || document).querySelector(sel); }

  function resolveMode(root) {
    var tag = qs('script[data-clue-mode]', root)
      || qs('script[src*="clue-infinite-scroll"]', root);
    var mode = tag && tag.dataset ? tag.dataset.clueMode : null;
    return mode === 'load_more' ? 'load_more' : 'infinite';
  }

  /* ------------------------------ styles ------------------------------- */

  function injectStyles() {
    if (document.getElementById('clue-is-styles')) return;
    var el = document.createElement('style');
    el.id = 'clue-is-styles';
    el.textContent = [
      '.clue-is-hidden-pagination .pagination{display:none}',
      '.clue-is-sentinel{display:block;width:100%}',
      '.clue-is-status{display:none;padding:2.5rem 0;text-align:center;font-size:.9em;opacity:.65}',
      '.clue-is-sentinel[data-busy="true"] .clue-is-status{display:block}',
      '.clue-is-more{display:none;padding:2.5rem 0;text-align:center}',
      '.clue-is-sentinel[data-mode="load_more"][data-armed="true"]:not([data-busy="true"]) .clue-is-more{display:block}',
      '.clue-is-spinner{display:inline-block;width:1.05em;height:1.05em;',
      'margin-inline-end:.6em;vertical-align:-.15em;border:2px solid currentColor;',
      'border-top-color:transparent;border-radius:50%;animation:clue-is-spin .7s linear infinite}',
      '@keyframes clue-is-spin{to{transform:rotate(360deg)}}',
      '@media (prefers-reduced-motion:reduce){.clue-is-spinner{animation-duration:2.5s}}'
    ].join('');
    document.head.appendChild(el);
  }

  /* ---------------------------- DOM helpers ---------------------------- */

  function buildSentinel() {
    var el = document.createElement('div');
    el.className = 'clue-is-sentinel';
    el.setAttribute('data-busy', 'false');
    el.setAttribute('data-armed', 'false');
    el.setAttribute('data-mode', MODE);
    el.innerHTML = '<div class="clue-is-status" role="status" aria-live="polite">'
      + '<span class="clue-is-spinner" aria-hidden="true"></span>'
      + '<span class="clue-is-status-text"></span></div>'
      + '<div class="clue-is-more">'
      + '<button type="button" class="btn clue-is-more-btn">' + TEXT_LOAD_MORE + '</button>'
      + '</div>';
    return el;
  }

  function setBusy(on) {
    if (!s.sentinel) return;
    s.sentinel.setAttribute('data-busy', on ? 'true' : 'false');
    var text = qs('.clue-is-status-text', s.sentinel);
    if (text) text.textContent = on ? TEXT_LOADING : '';
  }

  function setArmed(on) {
    if (s.sentinel) s.sentinel.setAttribute('data-armed', on ? 'true' : 'false');
  }

  function hidePagination(hide) {
    if (!s.paginationRow) return;
    s.paginationRow.classList.toggle('clue-is-hidden-pagination', !!hide);
  }

  // Give up for good on this page view, and put the theme back how it was.
  function abandon() {
    s.stopped = true;
    s.busy = false;
    if (s.io) { s.io.disconnect(); s.io = null; }
    if (s.controller) { try { s.controller.abort(); } catch (e) { /* noop */ } }
    setBusy(false);
    setArmed(false);
    hidePagination(false);
    if (s.sentinel) s.sentinel.style.display = 'none';
  }

  // Stop loading but stay wired up, ready for the next filter or sort change.
  // showPagination = false when the whole collection is now on screen (the old
  // page links would be misleading), true when there is nothing to hide.
  function pause(showPagination) {
    s.busy = false;
    if (s.io) { s.io.disconnect(); s.io = null; }
    setBusy(false);
    setArmed(false);
    hidePagination(!showPagination);
    if (s.sentinel) s.sentinel.style.display = 'none';
  }

  /* ---------------------------- the fetching --------------------------- */

  function nextUrlFrom(root) {
    var link = qs('.pagination__next', root);
    return link && link.getAttribute('href') ? link.href : null;
  }

  function withSectionId(url) {
    if (!s.sectionId) return url;
    return url + (url.indexOf('?') >= 0 ? '&' : '?') + 'section_id=' + encodeURIComponent(s.sectionId);
  }

  function loadNextPage() {
    if (s.busy || s.stopped || !s.nextUrl || !s.grid) return;

    s.busy = true;
    setBusy(true);

    var url = s.nextUrl;
    s.controller = ('AbortController' in window) ? new AbortController() : null;

    fetch(withSectionId(url), {
      credentials: 'same-origin',
      signal: s.controller ? s.controller.signal : undefined
    })
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.text();
      })
      .then(function (html) {
        var holder = document.createElement('template');
        holder.innerHTML = html;

        var incomingGrid = qs('.product-grid', holder.content);
        if (!incomingGrid || !incomingGrid.children.length) throw new Error('no products in response');

        if (!ANIMATE_NEW_PRODUCTS) {
          incomingGrid.querySelectorAll('[data-cc-animate]').forEach(function (el) {
            el.removeAttribute('data-cc-animate');
          });
        }

        // Insert as HTML so the markup is parsed inside the live document -
        // that is what upgrades <product-block> and fires its lazy-load init.
        s.grid.insertAdjacentHTML('beforeend', incomingGrid.innerHTML);

        s.pagesLoaded += 1;
        s.nextUrl = nextUrlFrom(holder.content);

        afterInsert();

        s.busy = false;
        setBusy(false);

        if (!s.nextUrl) {
          pause(false);                                   // reached the end
        } else if (MODE === 'load_more') {
          setArmed(true);                                 // show the button again
        } else if (MAX_AUTO_PAGES > 0 && s.pagesLoaded >= MAX_AUTO_PAGES) {
          pause(true);                                    // hand back to pagination
        } else if (s.io && s.sentinel) {
          s.io.observe(s.sentinel);                       // arm for the next one
        }
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') return;
        if (window.console) console.warn('[clue-infinite-scroll]', err);
        abandon();
      });
  }

  // The two things Symmetry does not re-run by itself after new cards appear.
  // Animations are handled by the theme's own MutationObserver in
  // assets/animate-on-scroll.js, so nothing is needed for those.
  function afterInsert() {
    try {
      // Desktop only, on purpose. saveProductGridSpacingData (main.js L3258)
      // walks EVERY .block-inner in the grid calling getOffsetTopFromDoc()
      // and reading clientHeight, and it interleaves those reads with
      // `block.dataset.gridRow = row` writes -- so each iteration's write
      // invalidates layout and the next iteration's read forces a full
      // synchronous re-layout. It also re-measures the whole grid, not just
      // the cards we appended, so the cost is O(n^2) in pages loaded: 30
      // blocks after page one, 120 after page four. And it runs from here,
      // which fires from the IntersectionObserver 800px before the bottom --
      // i.e. WHILE the shopper is mid-scroll.
      //
      // All of that work exists to precompute a scroll target for quick buy,
      // and quick buy is gated to >=768px at main.js L3045. Below that width
      // the panel never opens, so every one of those forced layouts is spent
      // on a feature the shopper cannot reach.
      if (window.theme && theme.quickBuy && typeof theme.quickBuy.saveProductGridSpacingData === 'function') {
        theme.quickBuy.saveProductGridSpacingData();
      }
    } catch (e) { /* quick buy is optional */ }

    try {
      s.grid.querySelectorAll('carousel-slider').forEach(function (el) {
        if (typeof el.refresh === 'function') el.refresh();
      });
    } catch (e) { /* sliders are optional */ }
  }

  /* ------------------------- wiring and rewiring ------------------------ */

  // Called on first load and again every time the theme swaps the grid
  // (filter change, sort change, or a pagination click the theme handled).
  function sync() {
    if (s.stopped) return;

    s.mode = MODE;
    s.grid = qs('.collection-listing .product-grid', s.section);
    s.pagesLoaded = 0;
    s.busy = false;
    if (s.io) { s.io.disconnect(); s.io = null; }
    if (s.controller) { try { s.controller.abort(); } catch (e) { /* noop */ } }
    if (s.sentinel) s.sentinel.setAttribute('data-mode', MODE);

    s.nextUrl = s.grid ? nextUrlFrom(s.paginationRow) : null;

    if (!s.grid || !s.nextUrl) {
      // One page of results, or none at all. Nothing to do here, but stay
      // listening in case a filter change brings a longer result set back.
      pause(true);
      return;
    }

    hidePagination(true);
    s.sentinel.style.display = '';
    setBusy(false);

    if (MODE === 'load_more') {
      setArmed(true);
      return;
    }

    setArmed(false);

    // The margin is deliberately one-sided: it reaches DOWN from the bottom of
    // the screen only. If it also reached up, a shopper parked in the footer
    // would sit inside the trigger zone, and Chrome's scroll anchoring would
    // keep them there after every insert - loading the whole collection in one
    // burst. Reaching down only means loading happens on the way down, once.
    s.io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        s.io.unobserve(entry.target);
        loadNextPage();
      });
    }, { rootMargin: '0px 0px ' + LOAD_AHEAD_PX + 'px 0px' });

    s.io.observe(s.sentinel);
  }

  function init() {
    var grid = qs('.collection-listing .product-grid');
    var paginationRow = grid && grid.closest('[data-section-id]')
      ? qs('.pagination-row', grid.closest('[data-section-id]'))
      : null;
    if (!grid || !paginationRow || !paginationRow.parentNode) return;

    MODE = resolveMode(document);

    injectStyles();

    s.stopped = false;
    s.section = grid.closest('[data-section-id]');
    s.paginationRow = paginationRow;

    var filterContainer = qs('filter-container[data-filter-section-id]', s.section);
    s.sectionId = filterContainer ? filterContainer.dataset.filterSectionId : null;

    // Sits between the grid and the pagination, outside every
    // [data-ajax-container], so the theme's filter swap leaves it alone and the
    // container order the theme relies on is unchanged.
    s.sentinel = buildSentinel();
    paginationRow.parentNode.insertBefore(s.sentinel, paginationRow);

    s.sentinel.addEventListener('click', function (evt) {
      if (!evt.target.closest('.clue-is-more-btn')) return;
      evt.preventDefault();
      setArmed(false);
      loadNextPage();
    });

    // .pagination-row has its innerHTML replaced by the theme on every filter,
    // sort or ajax page change - that is our cue to start again.
    s.mo = new MutationObserver(function () { sync(); });
    s.mo.observe(paginationRow, { childList: true });

    sync();
  }

  window.clueInfiniteScroll = {
    version: '1.1',
    state: s,
    refresh: sync,
    disable: abandon
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Theme editor: re-wire when the collection section is re-rendered.
  document.addEventListener('shopify:section:load', function (evt) {
    if (!evt.target || !evt.target.querySelector('.collection-listing')) return;
    if (s.mo) s.mo.disconnect();
    if (s.io) s.io.disconnect();
    s.stopped = false;
    s.io = null;
    s.mo = null;
    s.sentinel = null;

    // The re-rendered section carries its own script tag (not re-executed by
    // the browser, but readable). No tag = "Numbered pagination" was chosen in
    // the editor - leave the section stock.
    var tag = evt.target.querySelector('script[data-clue-mode]');
    if (!tag) return;
    MODE = tag.dataset.clueMode === 'load_more' ? 'load_more' : 'infinite';
    init();
  });
}());